.includeExcludeHeader {
  border-bottom: 2px solid #8F8C8C;
  padding: 12px;
  box-sizing: border-box;
  color: #020202;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 16px;
}